export const FETCH_ADVANCED =
  'ipfabric/Settings/DiscoverySnapshots/GlobalDiscoveryConfiguration/FETCH_ADVANCED';
